import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrReviewCategory.ts
var t = () => e("reviewCategory");
//#endregion
export { t as useTrReviewCategory };
